import { createSelector } from 'reselect';
import { DOCUMENT } from './constants';
import { initialState } from './reducers';
import { hasValue } from '@helpers/utils/utils';

const documentState = (state) => state[DOCUMENT];

const selDocumentData = createSelector(
  documentState,
  (_documentState) => _documentState.documentData,
);

const selFilterFormConfig = createSelector(documentState, (_documentState) => {
  return hasValue(_documentState.filterFormConfig)
    ? _documentState.filterFormConfig
    : initialState.filterFormConfig;
});
const selDocumentNotifyData = createSelector(
  documentState,
  (_documentState) => _documentState.documentNotifyData,
);

const selFilterNotifyConfig = createSelector(
  documentState,
  (_documentState) => {
    return hasValue(_documentState.filterNotifyConfig)
      ? _documentState.filterNotifyConfig
      : initialState.filterNotifyConfig;
  },
);
const selDocumentGuidelineData = createSelector(
  documentState,
  (_documentState) => _documentState.documentGuidelineData,
);

const selFilterGuidelineConfig = createSelector(
  documentState,
  (_documentState) => {
    return hasValue(_documentState.filterGuidelineConfig)
      ? _documentState.filterGuidelineConfig
      : initialState.filterGuidelineConfig;
  },
);

const selDocumentDetailData = createSelector(
  documentState,
  (_documentState) => _documentState.docDetailData,
);

const selDocumentCategoriesData = createSelector(
  documentState,
  (_documentState) => _documentState.documentCategoriesData,
);

export {
  selDocumentData,
  selFilterFormConfig,
  selDocumentDetailData,
  selDocumentCategoriesData,
  selDocumentNotifyData,
  selFilterNotifyConfig,
  selDocumentGuidelineData,
  selFilterGuidelineConfig,
};
